<template>
  <div style="padding: 20px;">
    <h3>客户信息</h3>
    <br>
    <a-form :form="form" labelAlign="left" >
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="客户姓名">
            <a-input
              placeholder="请输入"
              :maxLength="50"
              v-decorator="['customerName',{rules: [{ required: true, message: '请输入客户姓名' }]}]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="电话">
            <a-input
              placeholder="请输入"
              v-decorator="['customerPhone',{
                rules:[{pattern: /^1[34578]\d{9}$/, message: '请输入正确的手机号'}],
                validateTrigger: 'blur'
              }]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="省市区/县">
            <a-cascader 
              :options="cityData" 
              change-on-select 
              placeholder="请选择"
              v-decorator="['region']"
              :fieldNames="{ label: 'label', value: 'label', children: 'children' }"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="详细地址">
            <a-input placeholder="请输入" :maxLength="50" v-decorator="['address']"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="猪场类型">
            <a-radio-group v-decorator="['farmType',{rules:[{required: true, message: '请选择猪场类型'}]}]" >
              <a-radio v-for="el in farmTypeList" :key="el.farmTypeId" :value="el.farmTypeName">
                {{ el.farmTypeName }}
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="猪场性质">
            <a-radio-group v-decorator="['farmNature',{rules:[{required: true, message: '请选择猪场性质'}]}]">
              <a-radio v-for="el in farmPropertiesList" :key="el.farmPropertiesId" :value="el.farmPropertiesName">
                {{ el.farmPropertiesName }}
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="饲养模式">
            <a-radio-group v-decorator="['feedModel',{rules:[{required: true, message: '请选择饲养模式'}]}]">
              <a-radio v-for="el in feedingPatternList" :key="el.feedingPatternId" :value="el.feedingPatternName">
                {{ el.feedingPatternName }}
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="猪场规模（头）">
            <a-input-number 
              style="width: 100%;"
              :min="1"
              :max="10000000"
              placeholder="请输入" 
              v-decorator="['farmScale',{rules:[{required: true, message: '请输入猪场规模'}]}]"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="栏舍类型">
            <a-radio-group v-decorator="['fenceType',{rules:[{required: true, message: '请选择栏舍类型'}]}]">
              <a-radio v-for="el in fenceTypeList" :key="el.fenceTypeId" :value="el.fenceTypeName">
                {{ el.fenceTypeName }}
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="地板类型">
            <a-radio-group v-decorator="['floorType',{rules:[{required: true, message: '请选择地板类型'}]}]" >
              <a-radio v-for="el in floorTypeList" :key="el.floorTypeId" :value="el.floorTypeName">
                {{ el.floorTypeName }}
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="粪水处理">
            <a-radio-group v-decorator="['shitHandle',{rules:[{required: true, message: '请选择粪水处理'}]}]">
              <a-radio v-for="el in fecalWaterList" :key="el.fecalWaterId" :value="el.fecalWaterName">
                {{ el.fecalWaterName }}
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="所属工厂">
            <a-select 
              placeholder="请选择"
              @change="handleFactoryChange"
              v-decorator="['factoryName',{
                rules:[{required: true, message: '请选择所属工厂'}],
                initialValue:selectFactory
              }]"
            >
              <a-select-option v-for="el in factoryList" :key="el.factoryId" :value="el.factoryName">
                {{ el.factoryName }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="聚落/片区">{{settlementName}}</a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import {cityData} from '../../Common/region'
import {farmTypeList, farmPropertiesList, feedingPatternList, fenceTypeList, floorTypeList, fecalWaterList} from './Lists'
export default {
  props:['customerInfo'],
  data(){
    return{
      form: this.$form.createForm(this, { name: 'customer' }),
      cityData,
      farmTypeList,
      farmPropertiesList,
      feedingPatternList,
      fenceTypeList,
      floorTypeList,
      fecalWaterList,
      factoryList:[],
      settlementName:'',
      selectFactory:undefined
    }
  },
  watch:{
    customerInfo(){
      this.form.setFieldsValue(this.customerInfo)
      this.factoryGet()
    },
  },
  mounted(){
    this.form.setFieldsValue(this.customerInfo)
    this.factoryGet()
  },
  
  methods:{
    handleFactoryChange(value) {
      let factoryAnimalList = this.factoryList.find(item => item.factoryName == value)?.factoryAnimalList;
      let factoryId = this.factoryList.find(item => item.factoryName == value)?.factoryId;
      this.selectFactory = value
      this.settlementName = this.factoryList.find(item => item.factoryName == value)?.settlementName;
      let settlementId = this.factoryList.find(item => item.factoryName == value)?.settlementId;
      this.$emit('setFactory',  {selectFactory:this.selectFactory,settlementId,settlementName:this.settlementName,factoryId})
      if(!factoryAnimalList?.find(item => item.animalName =='1 猪')) {
        this.$warning({
          title: `暂无工厂“${value}”的猪线路填报权限`,
          content: '请确认工厂或负责线路是否有误',
        });
      }
    },
    async factoryGet() {
      let userId = window.localStorage.getItem('staffId')
      const res = await this.$http.get("/sat-collect/auth/permissions", { params:{userId} })
      let { success, data } = res;
      if (success) {
        let { factoryAndSettles} = data;
        this.factoryList = factoryAndSettles || [];
        if(!this.$route.query.copyId && !this.customerInfo.factoryName) this.handleFactoryChange(window.localStorage.getItem('factoryName'))
        else if(this.customerInfo.factoryName) this.handleFactoryChange(this.customerInfo.factoryName)
      }
    },
  }
}
</script>

<style>

</style>